import Vue from 'vue'
import App from './App.vue'
// import router from './router'
import router from '@/core/utils/router'
import { createPinia, PiniaVuePlugin } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import store from './store'

import { ROOT_CONFIG } from '@/utils/config'
import handleCloseDialog from '@/utils/handleCloseDialog'

// import '@/guards/authGuard'
import '@/core/utils/authGuard'
// import '@/core/utils/devFlagsGuard'
// import '@/core/utils/titleGuard'
import '@/element-ui'
import '@/global-components'
import '@/global-mixins'
import '@/icons-injection'
import '@/moment-js'
import '@/v-access'

import '@/assets/scss/custom-theme/main.scss'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/main.scss'
import { addFlagsSettingGlobalMethod } from './core/stores/FeatureFlags.store'

import { i18n } from './i18n'

Vue.config.productionTip = ROOT_CONFIG.productionTip
Vue.config.devtools = ROOT_CONFIG.devtools

Vue.prototype.$handleCloseDialog = handleCloseDialog

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

router.beforeEach((to, from, next) => {
  if (ROOT_CONFIG?.available) next()
})

new Vue({
  name: 'AppMain',
  router,
  store,
  pinia,
  i18n,
  // eslint-disable-next-line vue/component-api-style
  render: (h) => h(App),
}).$mount('#app')

addFlagsSettingGlobalMethod()
